import React, { useEffect, useState } from "react";
import Parse from "../../api/ApiConfig";
import { useOutletContext, useParams } from "react-router-dom";
import SavingsForm from "./sections/SavingsForm";
import { toast } from "react-toastify";
import { FormContainer } from "../../components/Form/FormComponents.styled";
import { fetchAFobject, fetchInvestorAssetObject, fetchSavingsObject } from "./utils";
import OngoingForm from "./sections/OngoingForm";
import SubmittedForm from "./sections/SubmittedForm";
import CompletedForm from "./sections/CompletedForm";
import CreatedAssetsForm from "./sections/CreatedAssetsForm";
import InvestorRequestForm from "./sections/InvestorRequestForm";

/* eslint-disable no-unused-vars */
const SingleApprenticeship = () => {
	let { category, id: requestId } = useParams();
	const [loading, setLoading] = useOutletContext();
	const [AFdata, setAFdata] = useState(null);

	const getCurrentObject = async () => {
		let data;
		switch (category) {
			case "savings":
				data = await fetchSavingsObject(requestId);
				break;
			case "created_assets":
			case "inactive":
			case "active":
			case "funded":
				data = await fetchInvestorAssetObject(requestId);
				break;
			default:
				data = await fetchAFobject(requestId);
				break;
		}
		// Handle response data
		if (data && !data?.error) {
			setLoading(false);
			setAFdata(data.result);
		} else {
			setLoading(false);
			setAFdata(data);
			toast.error(data?.error || "Error fetching data!");
		}
	};

	const updateCurrentObject = async (formData) => {
		setLoading(true);
		try {
			let ParseObj;
			switch (category) {
				case "created_assets":
				case "inactive":
					ParseObj = Parse.Object.extend("AFBusinessCreate");
					break;
				default:
					ParseObj = Parse.Object.extend("ApprenticeshipFinance");
					break;
			}
			const parseObject = new ParseObj();
			parseObject.id = requestId;

			// Save A.F data
			parseObject
				.save({
					type: formData.type,
					amountToRaise: formData.amountToRaise,
					amountToInvest: formData.amountToInvest,
					expectedProfit: formData.expectedProfit,
					amountToRepay: formData.amountToRepay,
					duration: formData.duration,
					waitingPeriod: formData.waitingPeriod,
					interestRate: formData.interestRate,
					programSavings: formData.programSavings,
					businessType: formData.businessType,
					businessDescription: formData.businessDescription,
					purpose: formData.purpose,
					approvalStatus: formData.approvalStatus,
					// documents: formData.documents,
					// commitmentFee: formData.commitmentFee,
				})
				.then((result) => {
					console.log("parseObject updated:", result);
					setLoading(false);
					toast.success("Object updated successfully!");
				});
		} catch (error) {
			console.log(error);
			setLoading(false);
			toast.error("Error updating Object!");
		}
	};

	// On page load
	useEffect(() => {
		setLoading(true);
		getCurrentObject();
	}, []);

	const CurrentPageForm = (props) => {
		switch (category) {
			case "ongoing":
				return <OngoingForm {...props} />;
			case "submitted":
				return <SubmittedForm {...props} />;
			case "completed":
				return <CompletedForm {...props} />;
			case "created_assets":
				return <CreatedAssetsForm {...props} />;
			case "savings":
				return <SavingsForm {...props} />;
			case "inactive":
			case "active":
			case "funded":
				return <InvestorRequestForm {...props} />;

			default:
				return <div className='text-center p-3'>[404] Error: Category not found!</div>;
		}
	};

	return (
		<FormContainer>
			{
				// Show CurrentPageForm if requestId is present and loading is false
				AFdata?.objectId && !loading ? (
					<CurrentPageForm AFdata={AFdata} setAFdata={setAFdata} updateCurrentObject={updateCurrentObject} />
				) : AFdata?.error ? (
					<div className='text-center fw-500 p-3'>Error fetching data!</div>
				) : null
			}
		</FormContainer>
	);
};

export default SingleApprenticeship;
